import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import ProductsSummary from '../../../components/ProductsSummary';
import Typography from '@material-ui/core/Typography/Typography';
import PlanItem from '../../../components/PlanItem';
import PlanSummary from '../../../components/PlanSummary';

const styles = theme => ({
  page: {
    width: '90%',
    'max-width': '1140px',
    'margin-top': '54px',
    'margin-left': 'auto',
    'margin-right': 'auto',
  },
  textField: {
    width: '100%',
  },
  button: {
    paddingTop: theme.spacing(),
  },
  title: {
    textAlign: 'center',
    marginBottom: 19,
    '&& > p:nth-child(1)': {
      color: '#00A1A1',
      fontSize: 14,
      fontWeight: 500,
      marginBottom: 8,
    },
    '&& > p:nth-child(2)': {
      color: '#212322',
      fontSize: 20,
      marginBottom: 0,
      fontWeight: 400,
    },
  },
  plansSummaryTitle: {
    '&& > p': {
      color: '#212322',
      fontSize: 20,
      marginTop: 24,
      marginBottom: 18,
      fontWeight: 400,
    },
  },
  plansTitle: {
    textAlign: 'center',
    marginBottom: 45,
    marginTop: 33,
    borderBottom: '1px solid rgba(178,178,178,0.5)',
    '&& > p:nth-child(1)': {
      color: '#212322',
      fontSize: 20,
      fontWeight: 400,
      marginBottom: 7,
    },
    '&& > p:nth-child(2)': {
      color: '#FF9200',
      fontSize: 14,
      fontWeight: 400,
      marginBottom: 15,
    },
  },
  cdTitle: {
    '&& > p': {
      color: '#212322',
      fontSize: 18,
      fontWeight: 500,
      marginBottom: 27,
      textTransform: 'uppercase',
    },
  },
});

const basicPlanItmes = [
  { value: 'Consent Approval Rate', enabled: true },
  { value: 'Basic Cookie Overview', enabled: true },
  { value: 'Single Consent Solution view', enabled: true },
  { value: 'Detailed Information About Each Cookie', enabled: true },
  { value: 'Export To Excel', enabled: true },
  { value: 'Executive Summary of Privacy and Compliance Risk', enabled: false },
  { value: 'In Depth Privacy Risks And GDPR Violations', enabled: false },
];

const advancedPlanItmes = [
  { value: 'Consent Insight And Trend', enabled: true },
  { value: 'Cookie Insights And Trend', enabled: true },
  { value: 'Multiable Consent Solution And Domain View', enabled: true },
  { value: 'Detailed Information About Each Cookie', enabled: true },
  { value: 'Export To Excel', enabled: true },
  { value: 'Executive Summary of Privacy and Compliance Risk', enabled: true },
  { value: 'In Depth Privacy Risks And GDPR Violations', enabled: true },
];

const cookieComplianceDashboardPlans = {
  compliance_dashboard_basic: basicPlanItmes,
  compliance_dashboard_advanced: advancedPlanItmes,
};

export const SubscriptionSummary = props => {
  if (!props.products) return null;
  const {
    paymentPeriod,
    classes,
    summaryProducts,
    products: { [paymentPeriod]: products },
    complianceDashboardPlan,
    onPlanChange,
    onPeriodChange,
    onSubmit,
  } = props;
  return (
    <Grid container spacing={5} className={classes.page}>
      <Grid item xs={9}>
        <Grid container spacing={5} direction="column">
          <Grid item xs={12} className={classes.title}>
            <Typography variant="subtitle1" paragraph={true}>
              PRICING BREAKDOWN
            </Typography>
            <Typography variant="h6" paragraph={true}>
              Consent Solution
            </Typography>
          </Grid>
        </Grid>
        <Grid container spacing={5}>
          {products.consent_solution ?
            <ProductsSummary products={products.consent_solution} paymentPeriod={paymentPeriod}/> : null}
        </Grid>
        <Grid container spacing={5}>
          <Grid item xs={12} className={classes.plansTitle}>
            <Typography variant="h6" paragraph={true}>
              Extend your plan with our Professional services
            </Typography>
            <Typography variant="body2" paragraph={true}>
              Add them below to extend your plan with extra features
            </Typography>
          </Grid>
        </Grid>
        <Grid container spacing={5}>
          <Grid item xs={12} className={classes.cdTitle}>
            <Typography variant="h6" paragraph={true}>
              cookie compliance dashboard
            </Typography>
          </Grid>
        </Grid>
        <Grid container spacing={5} wrap="nowrap">
          {products.compliance_dashboard ?
            products.compliance_dashboard.prices.map(price => <PlanItem
              key={price.price_id}
              item={price}
              listItems={cookieComplianceDashboardPlans[price.name]}
              paymentPeriod={paymentPeriod}
              selected={complianceDashboardPlan.name === price.name}
              onSelect={() => {
                onPlanChange(price);
              }}
              currency={products.compliance_dashboard.currency}/>) : null}
        </Grid>
      </Grid>
      <Grid item xs={3}>
        <Grid container spacing={5}>
          <Grid item xs={12} className={classes.plansSummaryTitle}>
            <Typography variant="h6" paragraph={true}>
              Plan summary
            </Typography>
          </Grid>
        </Grid>
        <PlanSummary
          paymentPeriod={paymentPeriod}
          items={summaryProducts}
          onSwitch={() => onPeriodChange()}
          onSubmit={() => onSubmit()}
        />
      </Grid>
    </Grid>
  );
};

export default withStyles(styles)(SubscriptionSummary);
